import {ChecklistItemModel} from "../../../../../models/checklist-model";
import {
    useActiveChecklistItemSelector,
    useAllTaskListSelector, useCompletedChecklistMapSelector
} from "../../../../../store/selectors/task/task.selectors";
import {useDispatch} from "react-redux";
import {
    useActiveProjectCalendarsSelector,
    useActiveProjectSelector,
    useCpmMapSelector
} from "../../../../../store/selectors/project.selectors";
import {useUserSelector} from "../../../../../store/selectors/authorization.selectors";
import ChecklistUtils from "../../../../../utils/checklist/checklist.utils";
import {convertDateToIndex} from "../../../../../utils/cpm-functions/cpm-app/functions/handleEvent";
import styles from "../../ChecklistPage/Checklist.module.scss";
import classNames from "classnames";
import * as taskActions from "../../../../../store/actions/task.actions";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck} from "@fortawesome/free-solid-svg-icons";
import ChecklistAttachmentInput from "../../ChecklistPage/components/ChecklistAttachmentInput";
import moment from "moment/moment";
import React from "react";
import {WorkPackage} from "../../../../../models/responses/work-package.model";

export default function WorkPackageChecklistItem(props: {
    checklistItem: ChecklistItemModel,
    title: string,
    index: number,
    workPackage: WorkPackage,
    // completionRecord: any
}) {
    const {checklistItem, title, index, workPackage} = props;
    const completedChecklistMap = useCompletedChecklistMapSelector();
    const completionRecord = completedChecklistMap.get(`${checklistItem.taskId}:${checklistItem.checklistItemId}`);
    const isIncomplete = !completionRecord
    const allTasks = useAllTaskListSelector();
    const dispatch = useDispatch();
    const selectedItem = useActiveChecklistItemSelector();
    const cpmMap = useCpmMapSelector();
    const calendarMap = useActiveProjectCalendarsSelector();
    const dataDate = new Date().setHours(0, 0, 0, 0) / 1000;
    const activeProject = useActiveProjectSelector();
    const user = useUserSelector();

    const completeChecklistItem = async () => {
        if (!activeProject || !user) return;
        await ChecklistUtils.completeWorkPackageChecklistItem(workPackage, checklistItem.checklistItemId, activeProject.contractId, user)
    }

    const uncheckChecklistItem = async () => {
        if (!workPackage || !activeProject || !user) return;
        await ChecklistUtils.uncheckWorkPackageChecklistItem(
            workPackage,
            checklistItem.checklistItemId,
            activeProject.contractId ? activeProject.contractId : 'unknown',
            user
        )
    }

    const generateDeadline = () => {
        const drivingTask = checklistItem.tMinusDays < 0 ? workPackage.drivingTaskStart : workPackage.drivingTaskEnd;
        if (!drivingTask) return;
        const cpmTask = cpmMap.get(drivingTask.task_id);
        if (!cpmTask) return;
        const workingHours = calendarMap.get(`whd:${cpmTask.cal_id}`)
        const dataDateIndex = convertDateToIndex(dataDate, cpmTask.cal_id, calendarMap);
        const halfHours = checklistItem.tMinusDays > 0 ?
            (cpmTask.lf + (checklistItem.tMinusDays * workingHours * 2)) - dataDateIndex :
            (cpmTask.ls + (checklistItem.tMinusDays * workingHours * 2)) - dataDateIndex;
        const days = Math.floor(halfHours / (workingHours * 2));

        return (<div className={days < 0 ? styles.ChecklistItemDeadlineCritical : styles.ChecklistItemDeadline}>
            {`${Math.floor(days)} day${Math.abs(days) > 1 ? 's' : ''}`}
            {days <= 0 ? <div className={styles.Critical}>
                <p className={styles.CriticalTag}>Critical</p>
            </div> : days < 5 ? <div className={styles.NearCritical}>
                <p className={styles.CriticalTag}>Near Critical</p>
            </div> : null}
        </div>)
    }

    const dayString = generateDeadline();

    return (
        <div className={classNames(styles.ChecklistItem, styles.WorkPackageChecklistItem,{
            [styles.CheckListItemSelected]: selectedItem && selectedItem.checklistItemId === checklistItem.checklistItemId && selectedItem.taskId === checklistItem.taskId,
        })} onClick={() => {
            dispatch(taskActions.Actions.setActiveChecklistItem(checklistItem))
            const task = allTasks.get(checklistItem.taskId);
            if (!task) {
                dispatch(taskActions.Actions.setActiveTask(null))
                return;
            }
            dispatch(taskActions.Actions.setActiveTask(task))
        }}
        >
            <div className={styles.ChecklistItemLeft} style={checklistItem.taskString ? {padding: "5px 0"}: {}}>
                <div className={styles.ChecklistItemIndex}>{checklistItem.completionRecord ? ' ' : checklistItem.index ? checklistItem.index : index}</div>
                <div className={isIncomplete ? styles.ChecklistItemCheckBoxUnchecked : styles.ChecklistItemCheckBoxChecked}
                     onClick={() => {
                         if (isIncomplete) {
                             completeChecklistItem().catch(e => console.error(e));
                         } else {
                             uncheckChecklistItem().catch(e => console.error(e));
                         }
                     }}
                >
                    <FontAwesomeIcon icon={faCheck} size='lg' />
                </div>
                <span>
                      <div className={styles.ChecklistItemName}>{checklistItem.itemName}</div>
                      <div className={styles.ChecklistItemTaskName}>{checklistItem.taskString}</div>
                </span>
                {checklistItem.completionRecord &&
                    <ChecklistAttachmentInput
                        checklistItem={checklistItem}
                        completionRecord={completionRecord}
                        deployment='checklist'
                        workPackage={workPackage}
                    />
                }
            </div>
            <div className={styles.ChecklistItemRight}>
                <div className={styles.ChecklistItemDueDate}>{moment(new Date(checklistItem.due * 1000)).format('DD-MMM-YY')}</div>
                {dayString}
            </div>
        </div>
    )
}